import React from 'react';
import DashboardSummary from './DashboardSummary';
import DashboardSummaryErrorBoundary from './DashboardSummaryErrorBoundary';

const DashboardSummaryWithErrorBoundary = (props) => (
  <DashboardSummaryErrorBoundary>
    <DashboardSummary {...props} />
  </DashboardSummaryErrorBoundary>
);

export default DashboardSummaryWithErrorBoundary;
export { default as SummaryButton } from './SummaryButton';
export { default as reducer } from './DashboardSummary.ducks';
export { default as sagas } from './DashboardSummary.sagas';
export * as actions from './DashboardSummary.ducks';
